export function toSentenceCase(text: string): string {
  if (!text) return '';

  return text
    .split(' ')
    .map((word, index) => {
      if (word.length > 1 && word === word.toUpperCase()) {
        return word;
      }
      if (index >= 1) {
        return word.toLowerCase();
      }

      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}
